<template>
  <div :class="['ai', cropsMark]">
    <h2 class="ai-page-title">选择基地：</h2>
    <AiMenubar :isMenubar="isMenubar" />
    <MyNav />
  </div>
</template>

<script>
export default {
  components: {
    AiMenubar: () => import("@/views/ai/components/aiMenubar.vue"),
    MyNav: () => import("@/components/MyNav.vue"),
  },
  data() {
    return {
      isMenubar: true,
      isSelect: false,
      isLandSelect: false,
      isCrop: false,
      cropsMark: "",
      cropsInfoMark: "",
      tabIndex: "",
      isProgress: false,
    };
  },
  created() {
    sessionStorage.setItem("navLeft", "-100vh");
  },
  methods: {
    changeLand() {
      this.$router.push({
        name: "aiLands",
      });
      this.isLandSelect = false;
      this.isMenubar = false;
    },
  },
};
</script>

<style scoped lang="less">
.ai {
  width: 100%;
  height: 100vh;
  padding: 65px 0 23px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background: url("../assets/image/ai/index/page_bg.png") center center
    no-repeat #071a2c;
  background-size: cover;

  .ai-page-title {
    width: 605px;
    margin-bottom: 100px;
    color: #ccc;
  }
}
</style>
